import { Component, computed, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { CreateItdcrRequest } from 'src/app/shared/models/data/createItdcrRequest.model';
import { Attachment, EnquiryAttachment, ItemAttachment } from 'src/app/shared/models/data/enquiry.model';
import { ItdcrOffice } from 'src/app/shared/models/data/getItdcrOffices';
import { AttachmentGroup, ItdcrAttachment, ItdcrAttachmentItem } from 'src/app/shared/models/data/itcdrAttachments';
import { Itdcr } from 'src/app/shared/models/data/itdcrList.model';
import { ItdcrMill } from 'src/app/shared/models/data/itdcrMill.model';
import { Items } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { CalculatedCols, CustomIcoCol, GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-modal-itdcr',
  templateUrl: './modal-itdcr.component.html',
  styleUrl: './modal-itdcr.component.scss'
})
export class ModalItdcrComponent implements OnInit {

  @Input() enquiryNo!: string;
  @Input() itemNo!: string;
  @Input() sourceEvent?: 'F' | 'P' | 'D';
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() enquiryStatus: string = "";
  @Input() columnsToShowItem!: string[];
  @Input() customIcoCols: CustomIcoCol[] = [];
  @Input() calculatedCols!: CalculatedCols[];
  @Input() customRenderers: any;
  @Input() customHeaderRenderers: any;
  @Output() onCancel = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<any>();

  items = signal<Items[]>([]);
  filteredItems = signal<Items[]>([]);
  currentStep = signal<1 | 2 | 3>(1);

  selectedItems: Items[] = [];

  selectedMill?: string;
  millOptionList: SelectOption[] = [];

  FValue: boolean = false;
  PValue: boolean = false;
  DValue: boolean = false;

  dueDate: string = '';
  notes: string = '';
  sendToOptionList: SelectOption[] = [];;
  selectedSendTo: any;
  itdcrAttachments: ItdcrAttachmentItem[] = [];
  enquiryItdcrAttachments: EnquiryAttachment[] = [];
  itemsItdcrAttachments: ItemAttachment[] = [];
  attachmentGroups: AttachmentGroup[] = []; // Grouped for accordion
  previousItdcrAttachments: ItdcrAttachment[] = [];
  excludedPreviousItdcrAttachmentIds: number[] = [];


  newAttachments: Attachment[] = [];      // newly added (in memory)



  constructor(public globals: Globals, private loader: TeiasoftLoaderService, private backendService: BackendService,
    private teiasoftToaster: TeiasoftToasterService, private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.loadItems();
  }

  onCancelClick() {
    this.reset();
    this.onCancel.emit();
  }

  onCloseClick() {
    this.reset();
    this.onClose.emit();
  }

  reset(): void {
    this.selectedItems = [];
    this.itemNo = '';
    this.previousItdcrAttachments = [];
    this.excludedPreviousItdcrAttachmentIds = [];
  }

  loadItems(): void {
    this.backendService.getItemsByEnquiryNo(this.enquiryNo)
      .pipe(
        map(res => res.items || [])
      )
      .subscribe(items => {
        this.items.set(items);
        this.buildMillOptions();
        this.setDefaultFPD();
      });
  }

  setDefaultFPD() {
    if (this.sourceEvent) {
      switch (this.sourceEvent) {
        case 'F':
          this.FValue = true;
          break;
        case 'P':
          this.PValue = true;
          break;

        case 'D':
          this.DValue = true;
          break;

      }
    }
  }

  getDataSetItems(enquiryItems: any) {
    let dataSetItems = new Array();
    for (var i = 0; i < enquiryItems.length; i++) {
      let _dataSet: GridDataset = new GridDataset();
      let _obj: Items = new Items();
      _obj = enquiryItems[i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }

          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      dataSetItems.push(_dataSet);
    }

    dataSetItems = dataSetItems.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );

    return dataSetItems;
  }

  buildMillOptions(): void {
    // build a Set of "millId|marketingRoute" from items
    const itemMillKeys = new Set<string>();
    for (const it of this.items()) {
      const id = it?.mill?.millId;
      const mr = it?.marketingRoute ?? it?.sms?.marketingRoute; // adjust to your model
      if (id != null && mr != null) itemMillKeys.add(`${id}|${mr}`);
    }

    this.millOptionList = []; // reset

    this.backendService.getItdcrMills().subscribe(res => {
      const itdcrMills = (res?.itdcrMills ?? [])
        .filter(m => m?.millId != null && m?.marketingRoute != null
          && itemMillKeys.has(`${m.millId}|${m.marketingRoute}`));

      for (const itdcrMill of itdcrMills) {
        const option = new SelectOption();
        option.value = itdcrMill.itdcrMillId;
        option.text = itdcrMill.itdcrMillName;
        option.extraData = itdcrMill;
        option.disabled = this.hasMillAlreadyOpenItdcr(itdcrMill.millId!, itdcrMill.marketingRoute!);

        if (option.disabled) {
          option.text += ` ${this.translate.instant('enquiryBook.pendingItdcr')}`;
        }

        this.millOptionList.push(option);
      }

      this.millOptionList.sort((a, b) => a.text.localeCompare(b.text));
      this.setDefaultMillOption();
    });
  }



  // if coming from item selection the mill should be the one related to the item
  // otherwise select the first occurency (not disabled)
  setDefaultMillOption(): void {

    const availableOptions = this.millOptionList.filter(mo => !mo.disabled);
    if (availableOptions.length > 0) {
      let itemMillId = null;
      if (this.itemNo) {
        const itm = this.items().find(i => i.itemNo! == this.itemNo!);
        itemMillId = availableOptions.find(opt => {
          const itdcrMill = opt.extraData as ItdcrMill;
          return itdcrMill.millId == itm?.mill?.millId && itdcrMill.marketingRoute == itm?.sms?.marketingRoute;
        })
      }

      this.onSelectedMill(itemMillId || availableOptions[0]);
    }

  }

  onRowSelection($event: any[]) {
    this.syncSelectedItemsToFiltered(($event || []).map(i => i.itemNo));
  }

  onSelectedMill($event: SelectOption) {
    this.selectedMill = $event.value;
    const itdcrMill = $event.extraData as ItdcrMill;
    this.filteredItems.set(this.getDataSetItems(this.items().filter(i => i.mill?.millId == itdcrMill.millId && i.sms?.marketingRoute == itdcrMill.marketingRoute)));
    this.selectedItems = [];

    // eventually set default itemNo
    if (this.itemNo && this.itemNo.length > 0) {
      this.syncSelectedItemsToFiltered([this.itemNo]);
    }
  }

  onSelectedSendTo($event: SelectOption) {
    this.selectedSendTo = $event.value;
  }

  onChangeDueDate($event: string) {
    this.dueDate = $event;
  }

  hasMillAlreadyOpenItdcr(millId: number, marketingRoute: string): boolean {
    return this.items().filter(i => i.mill?.millId == millId && i.sms?.marketingRoute == marketingRoute).some(i => i.icrIssued || i.idrIssued || i.itrIssued);
  }

  loadItdcrOffices(): void {
    this.backendService.getItdcrOfficesByParameters(Number(this.selectedMill), this.FValue, this.PValue, this.DValue, this.enquiryNo, this.getSelectedItemNos())
      .pipe(
        map(res => res.itdcrOffices || [])
      )
      .subscribe(offices => {
        this.buildItdcrOffices(offices);
      });
  }

  loadItdcrAttachments(): void {
    this.backendService.getAttachmentsForItdcrByEnquiryNo(this.enquiryNo, Number(this.selectedMill), this.getSelectedItemNos())
      .subscribe(res => {

        const enquiry = (res.enquiryAttachments || []) as EnquiryAttachment[];
        const items = (res.itemsAttachments || []) as ItemAttachment[];
        const itdcr = (res.itdcrAttachments || []) as ItdcrAttachment[];
        this.excludedPreviousItdcrAttachmentIds = [];

        //  flat
        this.itdcrAttachments = enquiry.concat(items).concat(itdcr);

        // sort each group by date desc (fallback undefined dates to 0)
        const byDateDesc = (a: ItdcrAttachmentItem, b: ItdcrAttachmentItem) =>
          (new Date(b.fileDate || 0).getTime()) - (new Date(a.fileDate || 0).getTime());

        const groups: AttachmentGroup[] = [
          {
            key: 'enquiry',
            label: this.translate.instant('itdcr.enquiryAttachments') || 'Enquiry attachments',
            items: [...enquiry].sort(byDateDesc)
          },
          {
            key: 'items',
            label: this.translate.instant('itdcr.itemsAttachments') || 'Items attachments',
            items: [...items].sort(byDateDesc)
          },
          {
            key: 'itdcr',
            label: this.translate.instant('itdcr.prevItdcrAttachments') || 'ITDCR attachments',
            items: [...itdcr].sort(byDateDesc)
          }
        ];

        this.previousItdcrAttachments = [...itdcr].sort(byDateDesc);

        // show only non-empty groups
        this.attachmentGroups = groups.filter(g => g.items.length > 0);
        this.enquiryItdcrAttachments = res.enquiryAttachments;
        this.itemsItdcrAttachments = res.itemsAttachments;
      });
  }

  buildItdcrOffices(offices: ItdcrOffice[]): void {
    this.sendToOptionList = offices.map(o => {
      const sc = new SelectOption();
      sc.isDefault = o.isDefault;
      sc.text = o.officeName;
      sc.value = o.officeId;
      return sc;
    })

    if (this.sendToOptionList && this.sendToOptionList.length > 0) {
      const defaultOpt = this.sendToOptionList.find(opt => opt.isDefault);
      this.selectedSendTo = defaultOpt ? defaultOpt.value : this.sendToOptionList[0].value
    }

  }

  // ---------------- NAVIGATION ----------------
  goTo(step: 1 | 2 | 3) {
    this.currentStep.set(step);

    if (step === 2) {
      this.loadItdcrAttachments();
    }
    if (step === 3) {
      this.loadItdcrOffices();
    }
  }

  nextStep() {
    if (!this.isCurrentStepComplete()) return;
    const s = this.currentStep();
    if (s < 3) {
      this.goTo((s + 1) as 1 | 2 | 3);
    } else {
      // if you call next on last step, behave like confirm
      this.save();
    }
  }

  prevStep() {
    const s = this.currentStep();
    if (s > 1) this.goTo((s - 1) as 1 | 2 | 3);
  }

  preview() {
    this.save(true);
  }

  save(preview: boolean = false) {
    const createItdcrRequest: CreateItdcrRequest = {
      attachments: this.newAttachments,
      technical: this.FValue,
      cost: this.PValue,
      delivery: this.DValue,
      dueDate: this.dueDate ? Number(this.dueDate) : null,
      enquiryNo: this.enquiryNo,
      itemsNo: this.getSelectedItemNos(),
      itdcrMillId: Number(this.selectedMill),
      toItdcrOfficeId: this.selectedSendTo,
      toNotes: this.notes,
      isPreview: preview,
      attachmentsIdFromPreviousVersion: this.getIncludedPreviousItdcrAttachmentIds()
    };

    this.loader.start();

    this.backendService.createItdcr(createItdcrRequest).subscribe(res => {

      if (preview && res.previewUrl) {
        window.open(res.previewUrl, '_blank', 'noopener,noreferrer');
        return;
      }
      else {
        this.teiasoftToaster.show('success', this.translate.instant('enquiryBook.itdcrCreated'));
        this.onClose.emit(res.itdcrNo);
      }
    }, null, () => {
      this.loader.stop();
    });
  }

  // ---------------- VALIDATION ----------------
  // Step 1 is valid when: mill selected, >=1 item selected, at least one of F/P/D is true
  isFirstStepComplete(): boolean {
    if (!this.selectedMill) return false;
    if (!this.selectedItems || this.selectedItems.length < 1) return false;
    if (!this.FValue && !this.PValue && !this.DValue) return false;
    return true;
  }


  isSecondStepComplete(): boolean {
    return true; // change when attachments logic arrives
  }

  // Step 3 valid when: send-to is selected (notes optional)
  isThirdStepComplete(): boolean {
    return this.selectedSendTo != null;
  }

  isStepComplete(step: 1 | 2 | 3): boolean {
    switch (step) {
      case 1: return this.isFirstStepComplete();
      case 2: return this.isSecondStepComplete();
      case 3: return this.isThirdStepComplete();
    }
  }

  isCurrentStepComplete(): boolean {
    return this.isStepComplete(this.currentStep());
  }

  private syncSelectedItemsToFiltered(itemNos: (number | string | undefined)[]): void {
    const selectedItemNos = new Set(itemNos.filter(itemNo => itemNo != null).map(itemNo => String(itemNo)));
    this.selectedItems = this.filteredItems().filter(item => selectedItemNos.has(String(item.itemNo)));
  }

  private getSelectedItemNos(): string[] {
    this.syncSelectedItemsToFiltered(this.selectedItems.map(item => item.itemNo));
    return this.selectedItems
      .map(item => String(item.itemNo))
      .filter(itemNo => itemNo !== 'undefined' && itemNo !== 'null' && itemNo !== '');
  }

  // --- Utils ---
  private stripBase64Header(dataUrl: string): string {
    const comma = dataUrl.indexOf(',');
    return comma >= 0 ? dataUrl.substring(comma + 1) : dataUrl;
  }

  private readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(this.stripBase64Header(String(reader.result)));
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  onAddAttachmentClick() {
    document.getElementById('itdcrFileUploadAttach')?.click();
  }

  // Add files coming from <input type="file" multiple>
  addNewFiles(event: any) {
    const files = Array.from(event.target?.files as any as File[]);

    //  basic constraints
    const MAX_FILES = 20;
    const MAX_SIZE = 25 * 1024 * 1024;   // 25MB each

    for (const f of files) {
      if (f.size > MAX_SIZE) {
        this.teiasoftToaster.show('error', this.translate.instant('commons.fileTooLarge'));
        continue;
      }
      this.readFileAsBase64(f).then(base64 => {
        this.newAttachments.push({
          fileContent: base64,
          fileName: f.name,
          fileCreationDate: f.lastModified || Date.now(),
        });

        event = null;
      });

    }
  }

  // Remove a new file (only from the in-memory list)
  removeNewAttachment(index: number) {
    this.newAttachments.splice(index, 1);
  }

  trackByAtt = (_: number, att: ItdcrAttachmentItem) =>
    this.getAttachmentId(att) ?? att.fileName ?? att.presignedUrl ?? _;

  isPreviousItdcrAttachment(att: ItdcrAttachmentItem): att is ItdcrAttachment {
    return (att as ItdcrAttachment).itdcrAttachmentId != null;
  }

  isPreviousItdcrAttachmentExcluded(att: ItdcrAttachmentItem): boolean {
    const id = this.getPreviousItdcrAttachmentId(att);
    return id != null && this.excludedPreviousItdcrAttachmentIds.includes(id);
  }

  togglePreviousItdcrAttachment(att: ItdcrAttachmentItem): void {
    const id = this.getPreviousItdcrAttachmentId(att);
    if (id == null) return;

    const idx = this.excludedPreviousItdcrAttachmentIds.indexOf(id);
    if (idx == -1) {
      this.excludedPreviousItdcrAttachmentIds.push(id);
    } else {
      this.excludedPreviousItdcrAttachmentIds.splice(idx, 1);
    }
  }

  private getIncludedPreviousItdcrAttachmentIds(): number[] {
    return this.previousItdcrAttachments
      .map(att => att.itdcrAttachmentId)
      .filter((id): id is number => id != null && !this.excludedPreviousItdcrAttachmentIds.includes(id));
  }

  private getPreviousItdcrAttachmentId(att: ItdcrAttachmentItem): number | null {
    return this.isPreviousItdcrAttachment(att) ? att.itdcrAttachmentId ?? null : null;
  }

  private getAttachmentId(att: ItdcrAttachmentItem): number | null {
    if ((att as ItdcrAttachment).itdcrAttachmentId != null) {
      return (att as ItdcrAttachment).itdcrAttachmentId ?? null;
    }
    if ((att as EnquiryAttachment).enquiryAttachmentId != null) {
      return (att as EnquiryAttachment).enquiryAttachmentId ?? null;
    }
    if ((att as ItemAttachment).attachmentsId != null) {
      return (att as ItemAttachment).attachmentsId ?? null;
    }
    return null;
  }

  // download existing attachment (uses presignedUrl)
  downloadExisting(att: ItdcrAttachmentItem) {
    if (!att.presignedUrl) return;
    window.open(att.presignedUrl, '_blank', 'noopener,noreferrer');
  }

}
